import { useEffect, useState } from 'react';
import s from './LoginWidget.module.css';

interface ICountdownProps {
  onResendPhone(): void;
}

export function Countdown({ onResendPhone }: ICountdownProps) {
  const [count, setCount] = useState(10);

  useEffect(() => {
    if (count === 0) {
      return;
    }

    const timeout = setTimeout(() => setCount(p => p - 1), 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [count]);

  if (count === 0) {
    return (
      <button className={s['reset-code-button']} onClick={onResendPhone}>
        Получить код ещё раз
      </button>
    );
  }

  return (
    <p className={s['repeat-code-message']} onClick={() => onResendPhone()}>
      Получить код ещё раз через {count} сек
    </p>
  );
}
